/* ==========================================================================
   BentoKids — Shared Smooth Scroll + Scroll Animation System
   Used sitewide (existing sections + all new sections/pages).
   Stack: Lenis (free, MIT) for smooth scroll + GSAP ScrollTrigger for reveals.
   Respects prefers-reduced-motion. Safe to call multiple times (idempotent).
   ========================================================================== */

window.BKScroll = (function () {
  var lenis = null;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var initialized = false;

  // Shared animation "philosophy" — same easing/duration everywhere so every
  // new section automatically feels consistent with the rest of the site.
  var DEFAULTS = {
    duration: 0.9,
    ease: "expo.out", // premium fast-start/slow-settle feel, built into GSAP core (no plugin needed)
    stagger: 0.08,
    distance: 32, // px of translate for fade-up/down/left/right
  };

  function initSmoothScroll() {
    if (reduced || typeof Lenis === "undefined") return;

    lenis = new Lenis({
      duration: 1.1,
      easing: function (t) {
        return Math.min(1, 1 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      smoothTouch: false,
      autoRaf: false
    });

    lenis.on("scroll", function () {
      ScrollTrigger.update();
    });

    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });

    ScrollTrigger.addEventListener("refresh", function () {
      lenis.resize();
    });

    gsap.ticker.lagSmoothing(1000, 16);
  }

  function animEndState(type) {
    var d = DEFAULTS.distance;
    switch (type) {
      case "fade-up":
        return { opacity: 0, y: d };
      case "fade-down":
        return { opacity: 0, y: -d };
      case "fade-left":
        return { opacity: 0, x: d };
      case "fade-right":
        return { opacity: 0, x: -d };
      case "zoom-in":
        return { opacity: 0, scale: 0.92 };
      case "fade":
        return { opacity: 0 };
      default:
        return { opacity: 0, y: d };
    }
  }

  function initReveals(scope) {
    if (typeof gsap === "undefined") return;
    scope = scope || document;

    var allEls = scope.querySelectorAll("[data-animate]:not([data-animate-done])");
    var els = Array.prototype.filter.call(allEls, function (el) {
      var groupParent = el.parentElement ? el.parentElement.closest("[data-animate-group]") : null;
      // Skip if this element is itself a direct child of a group container
      // (the group already animates it via stagger) — but keep the group
      // container itself, and keep independent data-animate elements.
      return !(groupParent && el.parentElement.hasAttribute("data-animate-group"));
    });

    if (reduced) {
      els.forEach(function (el) {
        gsap.set(el, {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        });
        el.setAttribute("data-animate-done", "");
      });
      return;
    }

    els.forEach(function (el) {
      var type = el.getAttribute("data-animate") || "fade-up";
      var delay = parseFloat(el.getAttribute("data-animate-delay") || "0");
      var groupStagger = el.hasAttribute("data-animate-group");

      el.setAttribute("data-animate-done", "");

      if (groupStagger) {
        var children = Array.from(el.children);
        gsap.set(children, animEndState(type));
        ScrollTrigger.create({
          trigger: el,
          start: "top 85%",
          once: true,
          onEnter: function () {
            gsap.to(children, {
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              duration: DEFAULTS.duration,
              ease: DEFAULTS.ease,
              stagger: DEFAULTS.stagger,
            });
          },
        });
      } else {
        gsap.set(el, animEndState(type));
        ScrollTrigger.create({
          trigger: el,
          start: "top 88%",
          once: true,
          onEnter: function () {
            gsap.to(el, {
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              duration: DEFAULTS.duration,
              ease: DEFAULTS.ease,
              delay: delay,
            });
          },
        });
      }
    });
  }

  function initMagnetic(scope) {
    if (reduced || typeof gsap === "undefined") return;
    scope = scope || document;
    var els = scope.querySelectorAll(".btn--magnetic:not([data-magnetic-bound])");
    els.forEach(function (el) {
      el.setAttribute("data-magnetic-bound", "");
      el.addEventListener("mousemove", function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(el, { x: x * 0.18, y: y * 0.25, duration: 0.4, ease: "power3.out" });
      });
      el.addEventListener("mouseleave", function () {
        gsap.to(el, { x: 0, y: 0, duration: 0.5, ease: "elastic.out(1, 0.4)" });
      });
    });
  }

  function init() {
    if (initialized) return;
    if (typeof gsap === "undefined") return; // GSAP failed to load / offline — fail silently, content stays visible
    if (typeof ScrollTrigger === "undefined") {
  return;
}
    gsap.registerPlugin(ScrollTrigger);
if (
  reduced ||
  typeof Lenis === "undefined" ||
  typeof ScrollTrigger === "undefined"
) {
  return;
}
    initSmoothScroll();
    initReveals(document);
    initMagnetic(document);

    // Re-scan when Shopify section editor re-renders a section (theme editor live preview).
    document.addEventListener("shopify:section:load", function (e) {
      initReveals(e.target);
      initMagnetic(e.target);

      if (lenis) {
        lenis.resize();
      }

      ScrollTrigger.refresh();
    });

    initialized = true;
  }

  // Public API so new sections / AJAX-loaded content (cart drawer, search results)
  // can trigger a re-scan without re-including this whole file.
  return {
    init: init,
    refresh: function (scope) {

  if (lenis) {
    lenis.resize();
  }

  if (typeof ScrollTrigger !== "undefined") {
    initReveals(scope);
    ScrollTrigger.refresh();
  }

},
    isReducedMotion: function () {
      return reduced;
    },
  };
})();

document.addEventListener("DOMContentLoaded", function () {

  window.BKScroll.init();

  window.addEventListener("load", function () {
    window.BKScroll.refresh();
  });

  window.addEventListener("resize", function () {
    window.BKScroll.refresh();
  });

});